import { Breadcrumbs } from "components/breadcrumbs";
import { CreateRoleForm } from "./components";

export const CreateOrgRole : React.FC = () => {
  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create Org's Role" />
      <CreateRoleForm />
    </div>
  );
}